import { useMemo } from 'react';
import Iframe from 'react-iframe';

import { useCampaign } from '@/hooks/client';

import styles from './CampaignPageSentiment.module.css';

interface CampaignPageSentimentProps {
  campaignId: string;
}

export function CampaignPageSentiment({ campaignId }: CampaignPageSentimentProps) {
  const { data = {}, isLoading } = useCampaign(campaignId);

  const memoData = useMemo(() => data as Api.Client.Campaign, [data]);

  if (!memoData?.sentiment_app_url) {
    return null;
  }

  return (
    <>
      <Iframe className={styles.campaignPageSummary} url={memoData?.sentiment_app_url} />

      {!isLoading && <div className={styles.campaignPageSummaryOverlay} />}
    </>
  );
}
